import { ReactNode } from "react";
import { FiX } from "react-icons/fi";
import { restrictiveAnalysisTokens } from "../tokens";

interface DetailModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
}

export function DetailModal({ open, title, onClose, children }: DetailModalProps) {
  const { brandBlue } = restrictiveAnalysisTokens.colors;

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/70 p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="max-h-[90vh] w-full max-w-5xl overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-slate-200 px-5 py-4">
          <h3 className="text-lg font-semibold" style={{ color: brandBlue }}>{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md p-1 text-slate-500 transition hover:bg-slate-100 hover:text-slate-700"
            aria-label="Fechar modal"
          >
            <FiX size={18} />
          </button>
        </div>

        <div className="max-h-[calc(90vh-72px)] overflow-y-auto px-5 py-4">{children}</div>
      </div>
    </div>
  );
}
